// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * OrganizationAttributes type.
 * @typedef {object} OrganizationAttributes
 * @property {string} id - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {boolean | null} creditor - Attribute value.
 * @property {boolean | null} customer - Attribute value.
 * @property {string | null} deliveryAddress - Attribute value.
 * @property {string | null} deliveryCity - Attribute value.
 * @property {string | null} deliveryCountry - Attribute value.
 * @property {string | null} deliveryZipCode - Attribute value.
 * @property {string | null} email - Attribute value.
 * @property {string | null} invoiceAddress - Attribute value.
 * @property {string | null} invoiceCity - Attribute value.
 * @property {string | null} invoiceCountry - Attribute value.
 * @property {string | null} invoiceZipCode - Attribute value.
 * @property {string | null} name - Attribute value.
 * @property {string | null} paymentInfo - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} vatNo - Attribute value.
 */
/**
 * Attributes accepted by OrganizationCreateAttributes.
 * @typedef {object} OrganizationCreateAttributes
 * @property {OrganizationAttributes["creditor"] | null} [creditor] - Permitted creditor value.
 * @property {OrganizationAttributes["customer"] | null} [customer] - Permitted customer value.
 * @property {OrganizationAttributes["deliveryAddress"] | null} [deliveryAddress] - Permitted deliveryAddress value.
 * @property {OrganizationAttributes["deliveryCity"] | null} [deliveryCity] - Permitted deliveryCity value.
 * @property {OrganizationAttributes["deliveryCountry"] | null} [deliveryCountry] - Permitted deliveryCountry value.
 * @property {OrganizationAttributes["deliveryZipCode"] | null} [deliveryZipCode] - Permitted deliveryZipCode value.
 * @property {OrganizationAttributes["email"] | null} [email] - Permitted email value.
 * @property {OrganizationAttributes["invoiceAddress"] | null} [invoiceAddress] - Permitted invoiceAddress value.
 * @property {OrganizationAttributes["invoiceCity"] | null} [invoiceCity] - Permitted invoiceCity value.
 * @property {OrganizationAttributes["invoiceCountry"] | null} [invoiceCountry] - Permitted invoiceCountry value.
 * @property {OrganizationAttributes["invoiceZipCode"] | null} [invoiceZipCode] - Permitted invoiceZipCode value.
 * @property {OrganizationAttributes["name"] | null} [name] - Permitted name value.
 * @property {OrganizationAttributes["paymentInfo"] | null} [paymentInfo] - Permitted paymentInfo value.
 * @property {OrganizationAttributes["vatNo"] | null} [vatNo] - Permitted vatNo value.
 */
/**
 * Attributes accepted by OrganizationUpdateAttributes.
 * @typedef {object} OrganizationUpdateAttributes
 * @property {OrganizationAttributes["creditor"] | null} [creditor] - Permitted creditor value.
 * @property {OrganizationAttributes["customer"] | null} [customer] - Permitted customer value.
 * @property {OrganizationAttributes["deliveryAddress"] | null} [deliveryAddress] - Permitted deliveryAddress value.
 * @property {OrganizationAttributes["deliveryCity"] | null} [deliveryCity] - Permitted deliveryCity value.
 * @property {OrganizationAttributes["deliveryCountry"] | null} [deliveryCountry] - Permitted deliveryCountry value.
 * @property {OrganizationAttributes["deliveryZipCode"] | null} [deliveryZipCode] - Permitted deliveryZipCode value.
 * @property {OrganizationAttributes["email"] | null} [email] - Permitted email value.
 * @property {OrganizationAttributes["invoiceAddress"] | null} [invoiceAddress] - Permitted invoiceAddress value.
 * @property {OrganizationAttributes["invoiceCity"] | null} [invoiceCity] - Permitted invoiceCity value.
 * @property {OrganizationAttributes["invoiceCountry"] | null} [invoiceCountry] - Permitted invoiceCountry value.
 * @property {OrganizationAttributes["invoiceZipCode"] | null} [invoiceZipCode] - Permitted invoiceZipCode value.
 * @property {OrganizationAttributes["name"] | null} [name] - Permitted name value.
 * @property {OrganizationAttributes["paymentInfo"] | null} [paymentInfo] - Permitted paymentInfo value.
 * @property {OrganizationAttributes["vatNo"] | null} [vatNo] - Permitted vatNo value.
 */
/**
 * Frontend model for Organization.
 * @augments {FrontendModelBase<OrganizationAttributes, OrganizationCreateAttributes, OrganizationUpdateAttributes, OrganizationAttributes["id"], string>}
 */
class Organization extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Organization",
      attributes: [
        "id",
        "createdAt",
        "creditor",
        "customer",
        "deliveryAddress",
        "deliveryCity",
        "deliveryCountry",
        "deliveryZipCode",
        "email",
        "invoiceAddress",
        "invoiceCity",
        "invoiceCountry",
        "invoiceZipCode",
        "name",
        "paymentInfo",
        "updatedAt",
        "vatNo",
      ],
      collectionCommands: [
        "countries",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      projects: {type: "hasMany"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      projects: "Project",
    }
  }

  /** @returns {OrganizationAttributes["id"]} - Attribute value. */
  id() { return /** @type {OrganizationAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {OrganizationAttributes["id"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {OrganizationAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {OrganizationAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {OrganizationAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {OrganizationAttributes["creditor"]} - Attribute value. */
  creditor() { return /** @type {OrganizationAttributes["creditor"]} */ (this.readAttribute("creditor")) }

  /**
   * @param {OrganizationAttributes["creditor"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["creditor"] | null} - Assigned value.
   */
  setCreditor(newValue) { return /** @type {OrganizationAttributes["creditor"] | null} */ (this.setAttribute("creditor", newValue)) }

  /** @returns {OrganizationAttributes["customer"]} - Attribute value. */
  customer() { return /** @type {OrganizationAttributes["customer"]} */ (this.readAttribute("customer")) }

  /**
   * @param {OrganizationAttributes["customer"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["customer"] | null} - Assigned value.
   */
  setCustomer(newValue) { return /** @type {OrganizationAttributes["customer"] | null} */ (this.setAttribute("customer", newValue)) }

  /** @returns {OrganizationAttributes["deliveryAddress"]} - Attribute value. */
  deliveryAddress() { return /** @type {OrganizationAttributes["deliveryAddress"]} */ (this.readAttribute("deliveryAddress")) }

  /**
   * @param {OrganizationAttributes["deliveryAddress"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["deliveryAddress"] | null} - Assigned value.
   */
  setDeliveryAddress(newValue) { return /** @type {OrganizationAttributes["deliveryAddress"] | null} */ (this.setAttribute("deliveryAddress", newValue)) }

  /** @returns {OrganizationAttributes["deliveryCity"]} - Attribute value. */
  deliveryCity() { return /** @type {OrganizationAttributes["deliveryCity"]} */ (this.readAttribute("deliveryCity")) }

  /**
   * @param {OrganizationAttributes["deliveryCity"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["deliveryCity"] | null} - Assigned value.
   */
  setDeliveryCity(newValue) { return /** @type {OrganizationAttributes["deliveryCity"] | null} */ (this.setAttribute("deliveryCity", newValue)) }

  /** @returns {OrganizationAttributes["deliveryCountry"]} - Attribute value. */
  deliveryCountry() { return /** @type {OrganizationAttributes["deliveryCountry"]} */ (this.readAttribute("deliveryCountry")) }

  /**
   * @param {OrganizationAttributes["deliveryCountry"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["deliveryCountry"] | null} - Assigned value.
   */
  setDeliveryCountry(newValue) { return /** @type {OrganizationAttributes["deliveryCountry"] | null} */ (this.setAttribute("deliveryCountry", newValue)) }

  /** @returns {OrganizationAttributes["deliveryZipCode"]} - Attribute value. */
  deliveryZipCode() { return /** @type {OrganizationAttributes["deliveryZipCode"]} */ (this.readAttribute("deliveryZipCode")) }

  /**
   * @param {OrganizationAttributes["deliveryZipCode"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["deliveryZipCode"] | null} - Assigned value.
   */
  setDeliveryZipCode(newValue) { return /** @type {OrganizationAttributes["deliveryZipCode"] | null} */ (this.setAttribute("deliveryZipCode", newValue)) }

  /** @returns {OrganizationAttributes["email"]} - Attribute value. */
  email() { return /** @type {OrganizationAttributes["email"]} */ (this.readAttribute("email")) }

  /**
   * @param {OrganizationAttributes["email"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["email"] | null} - Assigned value.
   */
  setEmail(newValue) { return /** @type {OrganizationAttributes["email"] | null} */ (this.setAttribute("email", newValue)) }

  /** @returns {OrganizationAttributes["invoiceAddress"]} - Attribute value. */
  invoiceAddress() { return /** @type {OrganizationAttributes["invoiceAddress"]} */ (this.readAttribute("invoiceAddress")) }

  /**
   * @param {OrganizationAttributes["invoiceAddress"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["invoiceAddress"] | null} - Assigned value.
   */
  setInvoiceAddress(newValue) { return /** @type {OrganizationAttributes["invoiceAddress"] | null} */ (this.setAttribute("invoiceAddress", newValue)) }

  /** @returns {OrganizationAttributes["invoiceCity"]} - Attribute value. */
  invoiceCity() { return /** @type {OrganizationAttributes["invoiceCity"]} */ (this.readAttribute("invoiceCity")) }

  /**
   * @param {OrganizationAttributes["invoiceCity"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["invoiceCity"] | null} - Assigned value.
   */
  setInvoiceCity(newValue) { return /** @type {OrganizationAttributes["invoiceCity"] | null} */ (this.setAttribute("invoiceCity", newValue)) }

  /** @returns {OrganizationAttributes["invoiceCountry"]} - Attribute value. */
  invoiceCountry() { return /** @type {OrganizationAttributes["invoiceCountry"]} */ (this.readAttribute("invoiceCountry")) }

  /**
   * @param {OrganizationAttributes["invoiceCountry"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["invoiceCountry"] | null} - Assigned value.
   */
  setInvoiceCountry(newValue) { return /** @type {OrganizationAttributes["invoiceCountry"] | null} */ (this.setAttribute("invoiceCountry", newValue)) }

  /** @returns {OrganizationAttributes["invoiceZipCode"]} - Attribute value. */
  invoiceZipCode() { return /** @type {OrganizationAttributes["invoiceZipCode"]} */ (this.readAttribute("invoiceZipCode")) }

  /**
   * @param {OrganizationAttributes["invoiceZipCode"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["invoiceZipCode"] | null} - Assigned value.
   */
  setInvoiceZipCode(newValue) { return /** @type {OrganizationAttributes["invoiceZipCode"] | null} */ (this.setAttribute("invoiceZipCode", newValue)) }

  /** @returns {OrganizationAttributes["name"]} - Attribute value. */
  name() { return /** @type {OrganizationAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {OrganizationAttributes["name"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {OrganizationAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {OrganizationAttributes["paymentInfo"]} - Attribute value. */
  paymentInfo() { return /** @type {OrganizationAttributes["paymentInfo"]} */ (this.readAttribute("paymentInfo")) }

  /**
   * @param {OrganizationAttributes["paymentInfo"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["paymentInfo"] | null} - Assigned value.
   */
  setPaymentInfo(newValue) { return /** @type {OrganizationAttributes["paymentInfo"] | null} */ (this.setAttribute("paymentInfo", newValue)) }

  /** @returns {OrganizationAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {OrganizationAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {OrganizationAttributes["vatNo"]} - Attribute value. */
  vatNo() { return /** @type {OrganizationAttributes["vatNo"]} */ (this.readAttribute("vatNo")) }

  /**
   * @param {OrganizationAttributes["vatNo"] | null} newValue - New attribute value.
   * @returns {OrganizationAttributes["vatNo"] | null} - Assigned value.
   */
  setVatNo(newValue) { return /** @type {OrganizationAttributes["vatNo"] | null} */ (this.setAttribute("vatNo", newValue)) }

  /**
   * Runs countries.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{countries: {countryCode: string, countryName: string}[]}>} - Command response.
   */
  static async countries(...commandArguments) {
    return /** @type {{countries: {countryCode: string, countryName: string}[]}} */ (await this.executeCustomCommand({
      commandName: "countries",
      commandType: "countries",
      payload: Organization.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns projects relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Organization, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Organization, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("projects")) }

  /**
   * Returns projects.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Organization, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projects() { return this.projectsRelationship() }

  /**
   * Returns loaded projects.
   * @returns {Array<import("./project.js").Project>} - Loaded related models.
   */
  projectsLoaded() { return this.projectsRelationship().loaded() }

  /**
   * Loads projects.
   * @returns {Promise<Array<import("./project.js").Project>>} - Loaded related models.
   */
  async loadProjects() { return await this.projectsRelationship().load() }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Organization)

export {Organization}

export default Organization
